import React from 'react';
import { MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { Field, useFormikContext } from 'formik';

import itemFormModel from '../models/createItemModel';
import { useGetInventoriesQuery, useGetItemCategoriesQuery } from '../../../redux/vmsApi';

const {
  formField: {
    itemCode,
    quantityUnit,
    description,
    categoryId,
    inventoryId,
    inventoryCode,
    inventoryDescription,
    categoryCode,
    categoryDescription
  },
} = itemFormModel;

interface OwnProps {
  editing?: boolean;
}

const CreateItemForm: React.FC<OwnProps> = (props) => {
  const { data: itemCategories = [] } = useGetItemCategoriesQuery({});
  const { data: inventories = [] } = useGetInventoriesQuery({});
  const { editing = false } = props;
  const { errors, touched, values, setFieldValue } = useFormikContext<any>();

  const unitOptions = [
    { value: 'm' }, { value: 'm²' }, { value: 'm³' }, { value: 'kg' }, { value: 'buckets' },
    { value: 'item' }, { value: 'unit' }, { value: 'length' }, { value: 'bags' }, { value: 'each' },
    { value: 'pack' }, { value: 'box' }, { value: 'litres' }, { value: 'Tonnes' }, { value: 'rolls' }, { value: 'pairs' },
  ];

  const handleInventoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedInventory = inventories.find(inv => inv.id === e.target.value);
    setFieldValue('inventoryId', e.target.value);
    if (selectedInventory) {
      setFieldValue('inventoryCode', selectedInventory.inventoryCode || '');
      setFieldValue('inventoryDescription', selectedInventory.description || '');
    }
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedCategory = itemCategories.find(cat => cat.id === e.target.value);
    setFieldValue('categoryId', e.target.value);
    if (selectedCategory) {
      setFieldValue('categoryCode', selectedCategory.categoryCode || '');
      setFieldValue('categoryDescription', selectedCategory.description || '');
    }
  };

  return (
    <Stack width="100%" spacing={5}>
      <Typography variant='h4' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        {editing ? 'Edit' : 'Add'} Item
      </Typography>

      {/* === Row 1 === */}
      <Stack direction={'row'} spacing={2}>
        <Field
          as={TextField}
          fullWidth
          {...itemCode}

          error={touched.itemCode && Boolean(errors.itemCode)}
          helperText={touched.itemCode && errors.itemCode}
        />

        <Field
          as={TextField}
          fullWidth
          select
          {...inventoryId}

          value={values.inventoryId || ''}
          onChange={handleInventoryChange}
          sx={{ backgroundColor: '#fff', borderRadius: 1 }}
          error={touched.inventoryId && Boolean(errors.inventoryId)}
          helperText={touched.inventoryId && errors.inventoryId}
        >
          {inventories.map(inventory => (
            <MenuItem key={inventory.id} value={inventory.id}>
              {inventory.inventoryCode} ({inventory.description})
            </MenuItem>
          ))}
        </Field>

        <Field
          as={TextField}
          fullWidth
          select
          {...quantityUnit}
          value={values.quantityUnit || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFieldValue('quantityUnit', e.target.value)
          }
          error={touched.quantityUnit && Boolean(errors.quantityUnit)}
          helperText={touched.quantityUnit && errors.quantityUnit}
          sx={{ minWidth: '100px' }}
        >
          {unitOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.value}
            </MenuItem>
          ))}
        </Field>

      

        {/* <Field
          as={TextField}
          fullWidth
          {...itemCost}
          type="number"
          error={touched.itemCost && Boolean(errors.itemCost)}
          helperText={touched.itemCost && errors.itemCost}
        /> */}
      </Stack>

      {/* === Row 2 === */}
      <Stack direction={'row'} spacing={2}>
      <Select
          value={values.isService ? 'true' : 'false'}
          onChange={(event) => {
            const isServiceBool = event.target.value === 'true';
            setFieldValue('isService', isServiceBool);
          }}
        >
          <MenuItem value="true">Service</MenuItem>
          <MenuItem value="false">Product</MenuItem>
        </Select>
        <Field
          as={TextField}
          fullWidth
          {...description}

          error={touched.description && Boolean(errors.description)}
          helperText={touched.description && errors.description}
        />

        <Field
          as={TextField}
          fullWidth
          select
          {...categoryId}
          value={values.categoryId || ''}
          onChange={handleCategoryChange}
          sx={{ backgroundColor: '#fff', borderRadius: 1 }}
          error={touched.categoryId && Boolean(errors.categoryId)}
          helperText={touched.categoryId && errors.categoryId}
        >
          {itemCategories.map(itemCategory => (
            <MenuItem key={itemCategory.id} value={itemCategory.id}>
              {itemCategory.categoryCode} ({itemCategory.description})
            </MenuItem>
          ))}
        </Field>
      </Stack>

      {/* === Hidden Fields === */}
      <Field type="hidden" {...inventoryCode} />
      <Field type="hidden" {...inventoryDescription} />
      <Field type="hidden" {...categoryCode} />
      <Field type="hidden" {...categoryDescription} />
    </Stack>
  );
};

export default CreateItemForm;
